import App from '../pageComponents/App';

export default App;
